module.exports = __webpack_public_path__ + "static/feature_img2-4dc179a27fc0772d230ca5d84b20f915.jpg";